import copyToClipboard from '../../common/modules/copyToClipboard/copyToClipboard';
import addActiveClass from '../../common/modules/utils/addActiveClass';
import removeActiveClass from '../../common/modules/utils/removeActiveClass';

export function copyCurrentUrl (targetClass = 'js-copy-current-url') {
  const targetEle = document.getElementsByClassName(targetClass);

  if (!targetEle) return;
  [...targetEle].forEach(ele => {
    ele.addEventListener('click', () => {
      copyToClipboard(window.location.href, onCopied);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  copyCurrentUrl();
});

function onCopied () {
  const banner = document.getElementsByClassName('js-copy-current-url-banner');
  if (!banner) return;
  if ([...banner][0].classList.contains('toast--active')) {
    return;
  }

  addActiveClass('js-copy-current-url-banner', 'toast--active');
  setTimeout(() => {
    removeActiveClass('js-copy-current-url-banner', 'toast--active');
  }, 3000 + 250 + 250); // slidein: 0.25s, stay: 3s, fadeout: 0.25s
}
